import getConfig from 'next/config';

export { getServerCookie } from './CookieUtils';

export const {
  publicRuntimeConfig: {
    CDN_STATIC_ASSETS,
    ENVIRONMENT_NAME,
    MIGRATED_PUBLISH_SECTIONS,
    BASE_URL,
    API_CLIENT_TIMEOUT,
    DFP_PHOTOBROWSER_REFRESH_THRESHOLD,
    DISPLAY_CERTIFIED_TRUSTED_DEALER_CARS_FILTER,
    HUBVISOR_SCRIPT_ENABLED,
    FEATURE_USE_NEW_CONVERSATION_API,
    FEATURE_ADP_STICKY_CTA_ALWAYS_VISIBLE,
    DISPLAY_RESERVATION,
    ENABLE_SYNC_CONVERT_SCRIPT,
    ENABLE_NEW_STRIPE_CHECKOUT,
    STRIPE_EXPERIMENT_NAME,
    STRIPE_EXPERIMENT_VARIATION_KEY,
    FEATURE_TRIMS_FILTER,
    CONVERT_ACCOUNT_ID,
    CONVERT_FULLSTACK_PROJECT_ID,
    FEATURE_TDP_UPDATES,
    FEATURE_FREE_HISTORY_CHECK,
    FEATURE_CARS_KEYWORD_SEARCH,
    PRISMIC_REPOSITORY_NAME,
  },
} = getConfig();
